export * from '../../functions/src/common/adminAccess';
import type { AdminRole } from '../../functions/src/common/adminAccess';

export function canAccessPlatformManagement(role: AdminRole | null | undefined): boolean {
    return role === 'Super' || role === 'Global';
}

export function canManageMsaDocuments(role: AdminRole | null | undefined): boolean {
    return role === 'Super' || role === 'Global';
}
